import tw from "twin.macro";

const InputLabel = tw.label`block mb-1.5 font-medium text-black-alpha`;

export default InputLabel;
